import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextKerning"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 18H14.1225L15.84 16.2825L14.7825 15.2175L11.25 18.75L14.7825 22.2825L15.84 21.2175L14.1225 19.5H22.5V18ZM10.5 15.75L15 3H13.5L9 15.75H10.5ZM9.75 3L6.75 12L3.75 3H2.25L6 13.5H7.5L11.25 3H9.75ZM21 13.5H22.5L18.75 3H17.25L13.5 13.5H15L15.75 11.25H20.25L21 13.5ZM16.2525 9.75L18 4.5L19.7475 9.75H16.2525Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextKerning.vue"]]);
